import useClassNames from '@medflex/hooks/useClassNames';
import React from 'react';
import { IconCloseSolid } from '../Icons';

const InactiveChatRemark = ({ children, className }) => {
  const cn = useClassNames(
    () => [
      'flex',
      'items-center',
      'justify-center',
      'text-slate-600',
      'text-sm',
      'bg-slate-200',
      'py-1',
      'px-2',
      className,
    ],
    [className],
  );
  return (
    <div className={cn}>
      <IconCloseSolid size="4" className="flex-shrink-0" />
      <span className="ml-2">{children}</span>
    </div>
  );
};

export default InactiveChatRemark;
